import ReactGA from 'react-ga';

/**
 * Initilze Google Analytics with Google Site Id
 * @param {string} googleSiteId
 */
export function googleAnalyticsInit(googleSiteId:string) {
    //If Google Site Id not provided or Google Analytics already initilized then return
    if(!googleSiteId) return;

    //Reinitilize Google Analytics
    // @ts-ignore
    window.ga = null;

    //DEV -  cookieDomain set to none due to unknown origin of Google Analytics request during Development
    //Could be localhost origin
    if(process.env.ENV_TYPE==='DEV')
        ReactGA.initialize(googleSiteId, { debug: true, titleCase: false, gaOptions: { cookieDomain: 'none' } });
    //PROD and UAT - Known .paymentus domain 
    else {
        ReactGA.initialize(googleSiteId, {titleCase: false});
    }
}

/**
 * Update Google Analytics Dimensional Data from UI State
 * @param {string} flowName 
 * @param {string} viewName 
 */
export function googleAnalyticsSetFlowAndView(flowName:string,viewName:string) {
    //If Google Analytics is not initilized then return
    if(!isGoogleAnalyticsInitilized()) return;

    /**
     * Init Dimensional Data
     * Google Analytics must have 2 dimensions created
     * First dimensions must be Flow Name
     * Second dimension must be View Name
     */
    googleAnalyticsSetDimensionalData({dimension1:flowName,dimension2:viewName});

    //Set Page View
    googleAnalyticsSetPageView();
}

/**
 * Used for Timeout, 5xx and 400 series errors
 */
export function googleAnalyticsSimplePageView() {
    //If Google Analytics is not initilized then return
    if(!isGoogleAnalyticsInitilized()) return;

    //No Dimensional Data to be capture for a simple page view
    googleAnalyticsSetDimensionalData({dimension1:null,dimension2:null});

    //Set Page View
    googleAnalyticsSetPageView();
}

/**
 * Set Dimensional Data
 * @param {Object} data 
 */
function googleAnalyticsSetDimensionalData(data: ReactGA.FieldsObject) {
    ReactGA.set(data);
}

/**
 * Set Page View
 * This will send collect call to Google Analytics based on the current page and 
 * dimensional data.
 */
function googleAnalyticsSetPageView() {
    ReactGA.pageview(window.location.pathname + window.location.search);
}

/**
 * Returns true or false if Google Analytics is initilzied
 * @returns {boolean}
 */
export function isGoogleAnalyticsInitilized() {
    // @ts-ignore
    return window.ga != null;
}

/**
 * Send Google Analytics OnClick Event action tag
 * @param {string} eventAction 
 */
export function googleAnalyticsOnClickEvent(eventAction: any) {
  //If Google Analytics is not initilized then return
  if(!isGoogleAnalyticsInitilized()) return;

  //Send Event Data for Button OnClick event
  ReactGA.event({
    category: 'OnClick',
    action: eventAction
  });

}